import withHelmet from '../HOC/withHelmet';
import Start from '../components/start';

export default withHelmet(Start, 'Start reading on Readeo');
